// extracted by mini-css-extract-plugin
export default {"container":"ConfirmDeleteAdmin_container__7bYpx"};